var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100 user-modal-register-plan-select-cm-view px-2" },
    [
      _c("div", { staticClass: "mb-3 text-center" }, [
        _c("p", { staticClass: "font-weight-bold font-size-200 mb-0" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm._f("trans")("Get Credits for")) +
              "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.isNewAccount
        ? _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center text-center mb-4 ml-n1 mt-n3 flex-wrap",
            },
            [
              _c(
                "div",
                { staticClass: "flex-grow-1 ml-1 mt-3 white-space-nowrap" },
                [
                  _c(
                    "label",
                    {
                      staticClass:
                        "btn btn-white rounded border btn-lg mb-0 py-3 px-4 w-100 d-inline-flex align-items-center",
                      class: {
                        "outline-info shadow-info": _vm.isProductionSelected,
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedPlan,
                            expression: "selectedPlan",
                          },
                        ],
                        staticClass: "mr-4 vuetiful-form-radio-button",
                        attrs: {
                          "data-user-modal-input-plan-cm-conversion-minutes":
                            "",
                          type: "radio",
                          name: "u_plan",
                          value: "cm_production",
                        },
                        domProps: {
                          checked: _vm._q(_vm.selectedPlan, "cm_production"),
                        },
                        on: {
                          change: function ($event) {
                            _vm.selectedPlan = "cm_production"
                          },
                        },
                      }),
                      _vm._v(_vm._s(_vm._f("trans")("Production"))),
                      _c("i", {
                        staticClass: "far fa-rocket ml-2_ lh-inherit",
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex-grow-1 ml-1 mt-3 white-space-nowrap position-relative",
                },
                [
                  _c(
                    "label",
                    {
                      staticClass:
                        "btn btn-white rounded border btn-lg mb-0 py-3 px-4 w-100 d-inline-flex align-items-center",
                      class: {
                        "outline-info shadow-info": _vm.isDevelopmentSelected,
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedPlan,
                            expression: "selectedPlan",
                          },
                        ],
                        staticClass: "mr-4 vuetiful-form-radio-button",
                        attrs: {
                          "data-user-modal-input-plan-cm-developer": "",
                          type: "radio",
                          name: "u_plan",
                          value: "cm_development",
                        },
                        domProps: {
                          checked: _vm._q(_vm.selectedPlan, "cm_development"),
                        },
                        on: {
                          change: function ($event) {
                            _vm.selectedPlan = "cm_development"
                          },
                        },
                      }),
                      _vm._v(_vm._s(_vm._f("trans")("Development"))),
                      _c("i", {
                        staticClass: "far fa-mug-hot ml-2_ lh-inherit",
                      }),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mb-4 rounded bg-white border p-4" }, [
        _c("p", { staticClass: "mb-1 font-size-150" }, [
          _vm._v(_vm._s(_vm._f("trans")("API credtis"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "color-stripe flex-row w-100 mb-4" },
          _vm._l(8, function (n) {
            return _c("div", { class: "bg-main-" + n })
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "mb-4 position-relative w-100 overflow-x-hidden",
            staticStyle: { "min-height": "195px" },
          },
          [
            _vm.isProductionSelected
              ? _c(
                  "ul",
                  { staticClass: "list-unstyled mb-0 w-100" },
                  _vm._l(_vm.features, function (feature, idx) {
                    return _c(
                      "li",
                      {
                        staticClass: "py-3 d-flex align-items-baseline",
                        class: { "border-top": idx !== 0 },
                      },
                      [
                        _c("i", { staticClass: "fa fa-check text-success" }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "pl-1",
                          domProps: { innerHTML: _vm._s(feature) },
                        }),
                      ]
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "pt-2 text-left w-100" }, [
                  _c("p", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm._f("trans")(
                            "For developing purposes you have 30 Credits for free every 24 hours."
                          )
                        ) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { domProps: { innerHTML: _vm._s(_vm.apiDocsLine) } }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.supportLink) },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.onSupportTextClicked.apply(null, arguments)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(_vm._f("trans")("Happy coding!"))),
                  ]),
                ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "bg-gray-light rounded p-3 d-flex flex-column align-items-start",
          },
          [
            _c("strong", { staticClass: "font-size-125 mb-1" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm._f("trans")("What is a Credit")) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm._f("trans")(
                      "A Credit is the amount of processing time a file uses on our servers. For example, if the file processing takes two minutes, then you spend two Credits. Certain premium jobs use more Credits per minute as specified on our pricing page."
                    )
                  ) +
                  "\n            "
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("ButtonWithLoadingState", {
        staticClass:
          "btn btn-success btn-lg btn-block font-weight-bold text-uppercase rounded mb-4",
        attrs: {
          "data-user-modal-button-submit": "",
          icon: "fa fa-arrow-right lh-1",
          text: _vm._f("trans")("Continue"),
          "is-state-loading": _vm.isSubmitting,
          "show-icon-after-text": true,
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.goToChooseBilling.apply(null, arguments)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }